/**
 * Quotation Comparison routes (FSD 4.2.4, P45 PS6-U69).
 *
 * Literal `path:` strings (R3: the conformance deep-link parser cannot read a constant).
 * INT spreads `COMPARISON_ROUTES` into `PROCUREMENT_ROUTES`, adds the nav item
 * `proc-comparisons` ("Quotation Comparison", section s-4.2.4) and redirects the legacy
 * `/procurement/rfqs/:id/evaluation` (routesC7.ts `procurement-rfq-evaluation`) to
 * `/procurement/comparisons/:id`. Until that redirect lands both paths render the same view
 * (it reads `rfqId` or `id`).
 *
 * Each permission is the one the screen's main read declares on the server.
 */

import type { RouteRecordRaw } from 'vue-router'

import { COMPARISON_PERMISSIONS } from '@/modules/procurement/rfq/evaluation/api'

export const COMPARISON_ROUTES: RouteRecordRaw[] = [
  {
    path: '/procurement/comparisons',
    name: 'procurement-comparisons',
    component: () => import('@/modules/procurement/rfq/evaluation/ComparisonsListView.vue'),
    meta: {
      titleKey: 'procurement.u69.routeTitles.comparisons',
      permission: COMPARISON_PERMISSIONS.rfqRead,
    },
  },
  {
    path: '/procurement/comparisons/:rfqId(\\d+)',
    name: 'procurement-comparison',
    component: () => import('@/modules/procurement/rfq/RfqEvaluationView.vue'),
    meta: {
      titleKey: 'procurement.u69.routeTitles.comparison',
      permission: COMPARISON_PERMISSIONS.rfqRead,
    },
  },
]

/** The same set as strings, for links inside the module. */
export const COMPARISON_PATHS = {
  comparisons: '/procurement/comparisons',
  comparison: (rfqId: number) => `/procurement/comparisons/${rfqId}`,
} as const
